import React from "react";
import "./ContentsList.css";

//const ThumbHost = "https://cloud-library.keyring.net";

function ContentsList({ documentsList, openViewer, config }) {
 const showPageList = config?.pageList === true || config?.pageList === "true";

 return (
  <div id="souces">
      {documentsList.length === 0 ? (
        <p>データがありません。</p>
      ) : (
        documentsList.map((contents) => {
          // APIからのレスポンス構造に合わせてプロパティを分割代入
          const { key_id, name, title, author, pages, urs_viewer_url } = contents;
          // Reactのkeyとして、まずcidを試み、なければnameをフォールバックとして使用
          const thumb = key_id ? `${key_id.substring(0, 2)}/${key_id}` : "";

          return (
            <div key={key_id} className="contents">
              {/* サムネイル画像 */}
              <img
                src={`${config.ThumbHost}/contents/${thumb}_thumb`}
                alt="Thumbnail"
                onClick={() => openViewer(key_id, 0, urs_viewer_url)}
                style={{ cursor: "pointer" }}
              />
              {/* タイトル */}
              <label>{title}</label>
              {author && <label>著者: {author}</label>}
              {/* ページリンク */}
              {showPageList && pages.map((page) => (
                <label
                  key={`${key_id}-${page}`}
                  className="page_link"
                  onClick={() => openViewer(key_id, page, urs_viewer_url)}
                  style={{ cursor: "pointer", color: "blue" }}
                >
                  {page}ページ目
                </label>
              ))}
            </div>
          );
        })
      )}
    </div>
 );

 }

 export default ContentsList;
